// Organization-specific form styles (extends shared form styles)
import { StyleSheet } from 'react-native';
import { sharedFormStyles } from '@/components/common/admin/desktop/sharedFormStyles';
import { ADMIN_COLORS } from '@/constants/admin';

export const organizationFormStyles = StyleSheet.create({
  // Import all shared styles
  ...sharedFormStyles,
  
  // Override container with specific padding for organization forms
  container: {
    flex: 1,
    paddingHorizontal: 20,
  },
  
  // Override section with specific vertical padding
  section: {
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  
  // Organization-specific styles
  paymentAccountField: {
    marginBottom: 16,
  },
});

